import React from "react"
import { FormattedMessage } from "react-intl"
import Integrations from "../../../integration/Integrations"
import { EventObjectDto } from "../../../state/event/Event"
import { INTEGRATION_KEY } from "../../../state/integration/Constants"
import { InvoiceDto } from "../../../state/invoice/models"
import Proposal from "../../../state/proposal/Proposal"
import DocumentEventExportedComponent from "./DocumentEventExportedComponent"

type OwnProps = {
    object: EventObjectDto
    invoice: InvoiceDto
    proposal: Proposal
}

const InvoiceCreatedFromHubspotEvent = (props: OwnProps) => {
    const type = props.object.attributes.entityType
    const Url = Integrations.getExternalOrderUrl(props.object)
    
    const renderMessage = () => {
        switch (type) {
        case "main":
            return <FormattedMessage
                id="invoice.analytics.events.exported.hubspot.text"
                defaultMessage="Invoice {identifier} was created from a HubSpot deal"
                values={{
                    identifier: <strong>{props.invoice.attributes.identifier}</strong>,
                }}
            />
        default:
            return <></>
        }
    }

    return <DocumentEventExportedComponent 
        url={Url}
        exportedMainMessage={renderMessage()}
        buttonMessage={<FormattedMessage
            id="invoice.analytics.events.exported.HubSpot.open"
            defaultMessage="Open deal in HubSpot"
        />}
        integrationLogo={{
            integrationKey: INTEGRATION_KEY.HUBSPOT,
            width: 100,
            height: 30,
        }}
    />
}


export default InvoiceCreatedFromHubspotEvent



// WEBPACK FOOTER //
// ./src/quote/analytics/events/invoice-exported-hubspot.component.tsx